import React, {useState} from "react";
import styled from "styled-components";
import { NavigationItem } from "./NavigationItem";
import config from "../../config/config";

const navigationItems = [
    { label: "Dashboard", isActive: true },
    { label: "POS", isActive: false, badge: "New" }
];

export const DashboardNavigation = () => {
    const [activeItem, setActiveItem] = useState("Dashboard");
    const openPOS = () => {
        window.open(config.posUrl, '_blank');
    }

    return (
        <NavigationContainer>
            {navigationItems.map((item, index) => (
                <NavigationItem
                    key={index}
                    label={item.label}
                    isActive={activeItem === item.label}
                    // TODO Uncomment this line to enable navigation item click
                    // TODO when POS login is possible from auth-app
                    // onClick={() => setActiveItem(item.label)}
                    onClick={item.label === "POS" ? openPOS : undefined}
                    badge={item.badge}
                    isFirst={index === 0}
                    isLast={index === navigationItems.length - 1}
                />
            ))}
        </NavigationContainer>
    );
}

const NavigationContainer = styled.nav`
  display: flex;
  width: 100%;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
`;


// WEBPACK FOOTER //
// ./src/containers/DashboardNavigation/DashboardNavigation.js